import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import { selectHeightFadeTimers } from 'src/store/selectors/transitions'
import { redrawHeightFadeKey } from 'src/actions/transitions'

const HeightFadeContainer = compose(
  connect(
    state => ({
      timers: selectHeightFadeTimers(state)
    }),
    dispatch => ({
      doAnimate: (id, speed) => dispatch(redrawHeightFadeKey(id, speed))
    })
  ),
  withProps(props => ({
    animating: Boolean(props.timers[props.id])
  }))
)

export default HeightFadeContainer
